/* eslint-disable */
export const EMAIL_REGEX =
  /^(?=.{1,80}$)(?=.{1,64}@)([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*|".+")@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
